<template>
    <header ref="siteHeader" class="header">
        <div class="container">
            <div class="row align-items-center">
                <a v-if="$slots.sitelogo" href="/" class="header__logo logo" aria-label="Go to home page">
                    <slot name="sitelogo"></slot>
                </a>
                <div v-if="showMegaNav && navigationData.length > 0" class="col align-self-stretch p-static">
                    <MegaNavigation :navigationData="navigationData" />
                </div>
                <DrawerNavigation v-if="showMobileNav && navigationData.length > 0" :navigationData="navigationData">
                    <template #mobilecontrols>
                        <slot name="mobilenavcontrols"></slot> 
                    </template>
                </DrawerNavigation>

                <div v-if="$slots.controls && showMegaNav" class="col-auto pl-0">
                    <slot name="controls"></slot> 
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import DrawerNavigation from '../components/DrawerNavigation.vue';
import MegaNavigation from '../components/MegaNavigation.vue';

function debounce(func, delay) {
    let timer;
    return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => func.apply(this, args), delay);
    };
}

export default {
    name: 'site-header',
    data() {
        return {
            showMobileNav: false,
            showMegaNav: false
        };
    },
    props: {
        navigationData: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    components: {
        DrawerNavigation,
        MegaNavigation
    },
    methods: {
        checkScreenWidth() {
            this.showMobileNav = window.innerWidth < 1400;
            this.showMegaNav = window.innerWidth >= 1400;
        },
        updateHeaderStyles() {
            const siteHeader = this.$refs.siteHeader;

            if (siteHeader) {
                const siteHeaderHeight = siteHeader.getBoundingClientRect().height;
                document.documentElement.style.setProperty('--header-height', `${siteHeaderHeight}px`);
            }
        },
        handleResize() {
            this.checkScreenWidth();
            this.updateHeaderStyles();
        },
    },
    mounted() {
        // Debounce the event listeners
        this.debouncedResizeHandler = debounce(this.handleResize, 100);

        this.handleResize();

        // Add listeners
        window.addEventListener('resize', this.debouncedResizeHandler);
        window.addEventListener('orientationchange', this.handleResize);
    },
    beforeUnmount() {
        // Cleanup listeners
        window.removeEventListener('resize', this.debouncedResizeHandler);
        window.removeEventListener('orientationchange', this.handleResize);
    }
};
</script>